import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { rem } from '../tokens/type.js';
import { BrandMark, SprocketGlyph } from './brand-mark.js';
/**
 * The frame for every pre-auth screen (sign in, forgot, reset, signup).
 *
 * On a laptop it is two panes: the brand colour on the left carrying the mark and one
 * line about the product, the form on the right on plain paper. On a phone the brand
 * collapses to a strip above the form.
 */
export function AuthShell({ brandName, pitch, supporting, title, lead, children, }) {
    return (_jsxs(Box, { sx: {
            minHeight: '100vh',
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'minmax(360px, 42%) minmax(0, 1fr)' },
            gridTemplateRows: { xs: 'auto 1fr', md: '1fr' },
            bgcolor: 'background.paper',
        }, children: [_jsxs(Box, { component: "aside", "aria-label": brandName, sx: (t) => ({
                    position: 'relative',
                    overflow: 'hidden',
                    bgcolor: 'primary.main',
                    color: t.palette.primary.contrastText,
                    display: 'flex',
                    flexDirection: 'column',
                    p: { xs: 2.5, md: 5.5 },
                    pt: { xs: 'calc(20px + env(safe-area-inset-top))', md: 5.5 },
                    minHeight: { xs: 0, md: '100vh' },
                }), children: [_jsx(Box, { "aria-hidden": "true", sx: (t) => ({
                            position: 'absolute',
                            right: -140,
                            top: -140,
                            width: 520,
                            height: 520,
                            color: alpha(t.palette.primary.contrastText, 0.07),
                            display: { xs: 'none', md: 'block' },
                            pointerEvents: 'none',
                        }), children: _jsx(SprocketGlyph, { size: 520 }) }), _jsx(Box, { sx: { position: 'relative' }, children: _jsx(BrandMark, { name: brandName, size: "md", onBrand: true }) }), _jsxs(Box, { sx: { position: 'relative', mt: { xs: 2, md: 'auto' }, maxWidth: 420 }, children: [_jsx(Typography, { component: "p", sx: {
                                    fontSize: { xs: rem(18), md: rem(32) },
                                    fontWeight: 600,
                                    letterSpacing: '-0.02em',
                                    lineHeight: 1.15,
                                    textWrap: 'balance',
                                    m: 0,
                                }, children: pitch }), supporting && (_jsx(Typography, { component: "p", sx: (t) => ({
                                    display: { xs: 'none', md: 'block' },
                                    mt: 1.75,
                                    fontSize: rem(15),
                                    lineHeight: 1.55,
                                    color: alpha(t.palette.primary.contrastText, 0.82),
                                    m: 0,
                                }), children: supporting }))] })] }), _jsx(Box, { component: "main", sx: {
                    display: 'grid',
                    placeItems: 'center',
                    p: { xs: 3, md: 6 },
                    pb: { xs: 'calc(24px + env(safe-area-inset-bottom))', md: 6 },
                }, children: _jsxs(Box, { sx: { width: '100%', maxWidth: 360 }, children: [(title || lead) && (_jsxs(Stack, { spacing: 0.75, sx: { mb: 3.5 }, children: [title && (_jsx(Typography, { variant: "h2", component: "h1", sx: { fontSize: rem(24) }, children: title })), lead && (_jsx(Typography, { variant: "body1", color: "text.secondary", children: lead }))] })), children] }) })] }));
}
//# sourceMappingURL=auth-shell.js.map